import { createLearningStore, getApiEndpoint as apiEndpoint, getAsyncLocalStorage as asyncLocalStorage, getLocale as locale } from './internal/createStore';
import { requestCategories, requestCategoryDetail, requestBulkPrice } from './actions/category';
import { sendNotification } from './actions/notification';
import { requestCategoryMovies } from './actions/category_movies';
import { requestMovieDetail } from './actions/movie';
import { requestNewsDetail, requestNewsList } from './actions/news';
import { requestInstructors } from './actions/instructor';
import { requestPayment, requestBulkPayment, requestCartPayment } from './actions/payment';
import { requestPaymentMovies } from './actions/payment_movies';
import { clearState, requestSignIn } from './actions/signIn';
import { requestSignUp } from './actions/signUp';
import { requestResetUser, requestUser, requestUpdateUser } from './actions/user';
import { requestVerify } from './actions/userVerify';
import { requestSignOut } from './actions/signOut';
import { requestContact, resetContact } from './actions/contact';
import { requestQuestionCategoryList } from './actions/question_category';
import { requestQuestionList } from './actions/question';
import { requestTokenRefresh } from './actions/user_refresh';
import { requestForgotPassword } from './actions/forgot_password';
import { requestResetPassword } from './actions/reset_password';
import { requestLicenseHistory } from './actions/license';
import { requestCheckCampaignCode, clearCheckCampaignCode } from './actions/campaign_code';
import { requestGetCart, requestAddCart, requestDeleteCart, requestClearCart } from './actions/cart';
import { sendPushToken, setPushState, requestPushState } from './actions/push_token';
import { requestDiscountPacks, requestDiscountPackDetail } from './actions/discount_pack';
import { requestBronzeCheck, requestBronzeEntry, requestBronzePayment } from './actions/bronze_test';
import { requestHomemadeCategories, requestHomemadeCategoryDetail } from './actions/homemade';
import { requestOnlineTestLog } from './actions/online_test_log';

if (!Array.prototype.pushOrUpdateById) {
  Array.prototype.pushOrUpdateById = function (elem) {
    var newData = Object.assign({}, this);
    var found = newData.findIndex(function (item) {
      return item['id'] === elem['id'];
    });

    if (found !== undefined && found !== -1) {
      newData[found] = elem;
    } else {
      newData.push(elem);
    }

    return newData;
  };
}

if (!Array.prototype.findById) {
  Array.prototype.findById = function (id) {
    var found = this.findIndex(function (item) {
      return item['id'] === id;
    });

    if (found !== undefined && found !== -1) {
      return this[found];
    } else {
      return undefined;
    }
  };
}

export { createLearningStore, apiEndpoint, locale, asyncLocalStorage, sendNotification, requestCategories, requestCategoryDetail, requestBulkPrice, requestCategoryMovies, requestMovieDetail, requestNewsList, requestNewsDetail, requestInstructors, requestPayment, requestBulkPayment, requestCartPayment, requestPaymentMovies, requestSignIn, requestSignUp, requestUser, requestResetUser, requestVerify, requestSignOut, requestContact, requestQuestionCategoryList, requestQuestionList, requestTokenRefresh, requestForgotPassword, requestResetPassword, requestLicenseHistory, requestUpdateUser, clearState, resetContact, requestCheckCampaignCode, clearCheckCampaignCode, sendPushToken, setPushState, requestPushState, requestGetCart, requestAddCart, requestDeleteCart, requestClearCart, requestDiscountPacks, requestDiscountPackDetail, requestBronzeCheck, requestBronzeEntry, requestBronzePayment, requestHomemadeCategories, requestHomemadeCategoryDetail, requestOnlineTestLog };